import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/guide',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/guide/processMap',
      name: 'processMap',
      component: () => import('@/pages/guide/processMap.vue'),
      meta: {
        ...meta,
        title: '业务办理流程',
        // requireAuth: true
      }
    },
    {
      path: '/guide/stationBasicInfo',
      name: 'stationBasicInfo',
      component: () => import('@/pages/guide/stationBasicInfo.vue'),
      meta: {
        ...meta,
        title: '车站基本信息',
        // requireAuth: true
      }
    },
    {
      path: '/guide/trainInfo',
      name: 'trainInfo',
      component: () => import('@/pages/guide/trainInfo.vue'),
      meta: {
        ...meta,
        title: '车辆信息',
        // requireAuth: true
      }
    },
    {
      path: '/guide/containerInfo',
      name: 'containerInfo',
      component: () => import('@/pages/guide/containerInfo.vue'),
      meta: {
        ...meta,
        title: '集装箱信息',
        // requireAuth: true
      }
    },
    {
      path: '/guide/price/freight',
      name: 'freight',
      component: () => import('@/pages/guide/priceFreight.vue'),
      meta: {
        ...meta,
        title: '运费',
        // requireAuth: true
      }
    },
    {
      path: '/guide/price/incidentalsInfo',
      name: 'incidentals',
      component: () => import('@/pages/guide/priceIncidentals.vue'),
      meta: {
        ...meta,
        title: '杂费',
        // requireAuth: true
      }
    },
    {
      path: '/guide/legalFile',
      name: 'legalFile',
      component: () => import('@/pages/guide/legalFile.vue'),
      meta: {
        ...meta,
        title: '法律法规及相关文件',
        // requireAuth: true
      }
    },
    {
      path: '/guide/insurance/insuranceNotice',
      name: 'insuranceNotice',
      component: () => import('@/pages/guide/insuranceNotice.vue'),
      meta: {
        ...meta,
        title: '投保须知',
        // requireAuth: true
      }
    },
    {
      path: '/guide/insurance/insuranceTerms',
      name: 'insuranceTerms',
      component: () => import('@/pages/guide/insuranceTerms.vue'),
      meta: {
        ...meta,
        title: '保险条款',
        // requireAuth: true
      }
    },
    {
      path: '/guide/handleFAQ',
      name: 'handleFAQ',
      component: () => import('@/pages/guide/handleQuestion.vue'),
      meta: {
        ...meta,
        title: '货运办理问题',
        // requireAuth: true
      }
    },
    {
      path: '/guide/newsInfo',
      name: 'newsInfo',
      component: () => import('@/pages/guide/newsInfo.vue'),
      meta: {
        ...meta,
        title: '新闻资讯',
        // requireAuth: true
      }
    },
    {
      path: '/guide/newsInfoDetail',
      name: 'newsInfoDetail',
      component: () => import('@/pages/guide/newsInfoDetail.vue'),
      meta: {
        ...meta,
        title: '新闻资讯详情',
        // requireAuth: true
      }
    },
    {
      path: '/guide/noticeInfo',
      name: 'noticeInfo',
      component: () => import('@/pages/guide/noticeInfo.vue'),
      meta: {
        ...meta,
        title: '通知公告',
        // requireAuth: true
      }
    },
    {
      path: '/guide/noticeInfoDetail',
      name: 'noticeInfoDetail',
      component: () => import('@/pages/guide/noticeInfoDetail.vue'),
      meta: {
        ...meta,
        title: '通知公告详情',
        // requireAuth: true
      }
    },
  ]
}
